export default "__VITE_ASSET__C87nXRcI__"